/*
  assets/nibec-cajon.js · Bigbuda T-0834 (18-oct-2026)
  Cajón del carrito CON productos (snippets/nibec-cajon-*.liquid). Se carga con defer solo con «Nibec · Cajón con productos»
  encendido. Delegación en document: sigue funcionando cuando el cajón se redibuja sin recargar la página.
  1) «+» de «Completa tu compra» suma 1 unidad con POST a /cart/add y vuelve a dibujar el cajón con el carrito actualizado
     (mismo flujo que product-form.js y assets/nibec-cart-vacio-cro.js; no crea un <product-form>).
  2) Mide, para Heatmap (data-hm-id) y GA4 (Shopify.analytics y dataLayer):
       nibec_carrito_completa_agregar / nibec_carrito_completa_ver   (producto, posición)
       nibec_carrito_cta                                               (ir_al_carrito, seguir_comprando, garantia, devolucion)
       nibec_carrito_condiciones_abrir                                 (se abrió «Ver condiciones»)
       nibec_carrito_beneficio_vista                                   (al abrir el cajón: siguiente beneficio, unidades, nivel)
     Todos llevan dispositivo (celular o computador).
  T-0853 (18-oct-2026): venta cruzada. Cada fila de «Completa tu compra» trae data-nbx-origen (par = viene de snippets/nibec-pares-datos.liquid,
  mas_vendido = relleno) y data-nbx-superficie (cajon o ficha). Los eventos del cajón conservan su nombre y suman origen; la ficha usa
       nibec_completa_ficha_ver / nibec_completa_ficha_agregar      (producto, posición, origen)
       nibec_completa_vista                                          (superficie, cuántos pares y cuántos más vendidos, handles)
*/
(function () {
  if (window.__nibecCajon) return;
  window.__nibecCajon = true;

  function dispositivo() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'celular' : 'computador';
  }

  function publicar(nombre, datos) {
    datos = Object.assign({ dispositivo: dispositivo() }, datos || {});
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(nombre, datos);
    } catch (err) {}
    try {
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: nombre }, datos));
    } catch (err) {}
  }

  function agregar(boton) {
    var cart = document.querySelector('cart-drawer');
    if (!cart || typeof cart.renderContents !== 'function' || boton.getAttribute('aria-busy') === 'true') return;
    boton.setAttribute('aria-busy', 'true');
    var seccion = boton.closest('.nbx-comp');
    var estado = seccion && seccion.querySelector('[data-nbx-estado]');
    if (estado) estado.textContent = 'Agregando al carrito';

    var cuerpo = new FormData();
    cuerpo.append('id', boton.getAttribute('data-nbx-agregar'));
    cuerpo.append('quantity', '1');
    cuerpo.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    cuerpo.append('sections_url', window.location.pathname);
    if (cart.setActiveElement) cart.setActiveElement(document.activeElement);

    fetch(window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: cuerpo
    })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp.status || !resp.sections) throw new Error(resp.description || 'sin secciones');
        cart.renderContents(resp);
        if (seccion && seccion.hasAttribute('data-nbx-ficha')) {
          // En la ficha el cajón se abre y el botón queda en «Agregado» (puede sumar otra unidad con otro clic).
          boton.removeAttribute('aria-busy');
          boton.classList.add('is-agregado');
          var txt = boton.querySelector('.nbx-comp__mas-txt');
          if (txt) txt.textContent = 'Agregado';
          if (estado) estado.textContent = 'Agregado al carrito';
        }
      })
      .catch(function () {
        boton.removeAttribute('aria-busy');
        if (estado) estado.textContent = 'No se pudo agregar el producto. Intenta de nuevo.';
      });
  }

  // Datos de la fila (origen y superficie) para los eventos de «Completa tu compra».
  function fila(el) {
    var li = el.closest ? el.closest('.nbx-comp__item') : null;
    return {
      origen: (li && li.getAttribute('data-nbx-origen')) || 'mas_vendido',
      superficie: (li && li.getAttribute('data-nbx-superficie')) || 'cajon'
    };
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var ag = t.closest('[data-nbx-agregar]');
      if (ag) {
        var fa = fila(ag);
        publicar(fa.superficie === 'ficha' ? 'nibec_completa_ficha_agregar' : 'nibec_carrito_completa_agregar', { destino: ag.getAttribute('data-nbx-dato') || '', posicion: parseInt(ag.getAttribute('data-nbx-pos'), 10) || 0, origen: fa.origen });
        agregar(ag);
        return;
      }
      var link = t.closest('[data-nbx-click]');
      if (!link) return;
      var tipo = link.getAttribute('data-nbx-click');
      if (tipo === 'completa_ver') {
        var fv = fila(link);
        publicar(fv.superficie === 'ficha' ? 'nibec_completa_ficha_ver' : 'nibec_carrito_completa_ver', { destino: link.getAttribute('data-nbx-dato') || '', posicion: parseInt(link.getAttribute('data-nbx-pos'), 10) || 0, origen: fv.origen });
      } else {
        publicar('nibec_carrito_cta', { tipo: tipo });
      }
    },
    true
  );

  // «Ver condiciones»: el evento toggle no burbujea, se escucha en captura.
  document.addEventListener(
    'toggle',
    function (e) {
      var d = e.target;
      if (d && d.classList && d.classList.contains('nbx-ben__cond') && d.open) publicar('nibec_carrito_condiciones_abrir', {});
    },
    true
  );

  // Al abrir el cajón con productos: qué beneficio se mostró como «el siguiente».
  var vistoEnEstaApertura = false;
  function medirVista() {
    var b = document.querySelector('cart-drawer [data-nbx-ben]');
    if (!b || vistoEnEstaApertura) return;
    vistoEnEstaApertura = true;
    medirCompleta(document.querySelector('cart-drawer .nbx-comp'), 'cajon');
    publicar('nibec_carrito_beneficio_vista', {
      siguiente: b.getAttribute('data-nbx-siguiente') || '',
      unidades: parseInt(b.getAttribute('data-nbx-unidades'), 10) || 0,
      nivel: parseInt(b.getAttribute('data-nbx-nivel'), 10) || 0,
      envio_gratis: b.getAttribute('data-nbx-envio') === '1' ? 'si' : 'no'
    });
  }

  // «Completa tu compra» visto: cuántas filas vienen de los pares y cuántas de los más vendidos (una vez por apertura del cajón o por ficha).
  function medirCompleta(seccion, superficie) {
    if (!seccion) return;
    var filas = seccion.querySelectorAll('.nbx-comp__item');
    var pares = seccion.querySelectorAll('.nbx-comp__item[data-nbx-origen="par"]').length;
    var handles = [].map.call(filas, function (li) { return li.getAttribute('data-nbx-handle') || ''; }).join(',');
    publicar('nibec_completa_vista', { superficie: superficie, pares: pares, mas_vendidos: filas.length - pares, productos: handles });
  }

  function iniciar() {
    var ficha = document.querySelector('[data-nbx-ficha]');
    if (ficha && window.IntersectionObserver) {
      var ob = new IntersectionObserver(function (es) {
        if (es.some(function (x) { return x.isIntersecting; })) { ob.disconnect(); medirCompleta(ficha, 'ficha'); }
      }, { threshold: 0.4 });
      ob.observe(ficha);
    }
    var cd = document.querySelector('cart-drawer');
    if (!cd || !window.MutationObserver) return;
    new MutationObserver(function (muts) {
      var cambioClase = muts.some(function (m) { return m.type === 'attributes' && m.target === cd; });
      if (!cambioClase) return;
      if (cd.classList.contains('active')) window.setTimeout(medirVista, 150);
      else vistoEnEstaApertura = false;
    }).observe(cd, { attributes: true, attributeFilter: ['class'] });
    if (cd.classList.contains('active')) medirVista();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
